module.exports = __webpack_public_path__ + "img/66exp.24e5bb0d.jpg";